import React, {Component} from 'react';
import {HeadingMedium} from 'baseui/typography';
import {FlexGrid, FlexGridItem} from 'baseui/flex-grid';
import {Card, StyledBody, StyledAction} from 'baseui/card';
import microsoft_logo from '../images/platforms/windows/windows.svg';
import linux_logo from '../images/platforms/linux/linux.svg';
import apple_logo from '../images/platforms/apple.svg';
import android_logo from '../images/platforms/android/android.svg';
import About from '../About';
import * as ROUTES from '../Routes';
import { Button, SIZE } from 'baseui/button';
import Footer from '../Footer';

const itemProps = {
    //minWidth: '350px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

const cardProps = {
    padding: '10px',
    borderWidth: '0px',
};

const cardImageProps = {
    width: '175px',
    margin: 'auto',
    display: 'flex',
    padding: '50px 0px 50px 0px'
};

class Wall extends Component {
    renderPlatforms = () => {
        return <div className={"GridParent"}>
            <Card
                overrides={{
                    Root: {
                        style: ({ $theme }) => ({
                            ...cardProps
                        })
                    },
                    HeaderImage: {style: {...cardImageProps}}
                }}
                headerImage={microsoft_logo}
                title="Microsoft"
                hasThumbnail={() => true}
            >
                <StyledBody>
                    EncLock is available for Windows OS!
                </StyledBody>
                <StyledAction>
                    <FlexGrid>
                        <FlexGridItem {...itemProps}>
                            <Button $as="a" href={ROUTES.MICROSOFT} size={SIZE.compact}>More</Button>
                        </FlexGridItem>
                    </FlexGrid>
                </StyledAction>
            </Card>

            <Card
                overrides={{
                    Root: {
                        style: ({ $theme }) => ({
                            ...cardProps,
                            // opacity: 0.5
                        })
                    },
                    HeaderImage: {style: {...cardImageProps}}
                }}
                headerImage={apple_logo}
                title="Apple"
                hasThumbnail={() => true}
            >
                <StyledBody>
                    EncLock is available for MacOS and iOS!
                </StyledBody>
                <StyledAction>
                    <FlexGrid>
                        <FlexGridItem {...itemProps}>
                            <Button $as="a" href={ROUTES.APPLE} size={SIZE.compact}>More</Button>
                        </FlexGridItem>
                    </FlexGrid>
                </StyledAction>
            </Card>

            <Card
                overrides={{
                    Root: {
                        style: ({ $theme }) => ({
                            ...cardProps
                        })
                    },
                    HeaderImage: {style: {...cardImageProps}}
                }}
                headerImage={android_logo}
                title="Android"
                hasThumbnail={() => true}
            >
                <StyledBody>
                    EncLock is available for Android!
                </StyledBody>
                <StyledAction>
                    <FlexGrid>
                        <FlexGridItem {...itemProps}>
                            <Button $as="a" href={ROUTES.ANDROID} size={SIZE.compact}>More</Button>
                        </FlexGridItem>
                    </FlexGrid>
                </StyledAction>
            </Card>

            <Card
                overrides={{
                    Root: {
                        style: ({ $theme }) => ({
                            ...cardProps
                        })
                    },
                    HeaderImage: {style: {...cardImageProps}}
                }}
                headerImage={linux_logo}
                title="Linux"
                hasThumbnail={() => true}
            >
                <StyledBody>
                    EncLock is available for Linux distributions!
                </StyledBody>
                <StyledAction>
                    <FlexGrid>
                        <FlexGridItem {...itemProps}>
                            <Button $as="a" href={ROUTES.LINUX} size={SIZE.compact}>More</Button>
                        </FlexGridItem>
                    </FlexGrid>
                </StyledAction>
            </Card>
        </div>
    };

    render = () => {
        return <FlexGrid flexGridRowGap={'scale400'}>
            <FlexGridItem><About short={true}/></FlexGridItem>
            <FlexGridItem {...itemProps}><HeadingMedium>Platforms</HeadingMedium></FlexGridItem>
            <FlexGridItem>{this.renderPlatforms()}</FlexGridItem>
            <FlexGridItem><Footer /></FlexGridItem>
        </FlexGrid>
    };
}

export default Wall;